import { ExploreInsightDirection } from '@api/api/explore-filter-schema';
import { InsightDirection } from '@api/api/insights';

export const getExploreDirection = (
  direction: InsightDirection
): ExploreInsightDirection => {
  switch (direction) {
    case InsightDirection.Unspecified:
      return ExploreInsightDirection.Bullish;
    case InsightDirection.Bullish:
      return ExploreInsightDirection.Bullish;
    default:
      return ExploreInsightDirection.Bearish;
  }
};
